import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import { loadRuntimeConfig } from "@/lib/runtimeConfig";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

loadRuntimeConfig().then(async () => {
  const { default: App } = await import("@/App");
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}).catch((error) => {
  const root = document.getElementById("root");
  if (root) root.innerHTML = `<main style="font-family:system-ui;padding:3rem"><h1>Configuração incompleta</h1><p>${error.message}</p></main>`;
});
